import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import * as moment from 'moment'
import { lastValueFrom, Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import { SalesService } from 'src/app/services/api/sales.service'

@Component({
  selector: 'app-reporte-costos',
  templateUrl: './reporte-costos.component.html',
  styleUrls: ['./reporte-costos.component.scss']
})
export class ReporteCostosComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>()

  egresos: any = []

  displayedColumns: string[] = [
    'fileNumber',
    'nombre',
    // 'categoria',
    // 'peso',
    'dateRange',
    //  'costo',
    'costo'
    //'modificar',
    //'eliminar'
  ]

  dataSource: any

  loading: boolean = true

  files: any[] = []

  startDate: Date | any
  endDate: Date | any

  @ViewChild(MatPaginator) paginator!: MatPaginator

  constructor (
    public dialog: MatDialog,
    private readonly alimentosService: AyBService,
    private readonly salesService: SalesService
  ) {}

  ngOnInit (): void {
    this.getAllInsumos()
    this.dataSource = new MatTableDataSource()
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
  }

  async getAllInsumos () {
    const files = (
      await lastValueFrom(
        this.salesService
          .getAllFiles()
          .pipe(takeUntil(this._unsubscribeOnDestroy$))
      )
    ).getAllFiles

    await Promise.all(
      files.map(async (file: any) => {
        const egresos = (
          await lastValueFrom(
            this.alimentosService
              .queryGetAllEgresosInsumosByFileId({ fileId: file.id })
              .pipe(takeUntil(this._unsubscribeOnDestroy$))
          )
        ).getAllEgresosInsumosByFileId
        // console.log(egresos);
        const partes = file.dateRange.split('-')
        if (egresos.length > 0) {
          this.files.push({
            fileId: file.id,
            fileNumber: file.fileNumber,
            fileName: file.nombreItinerario,
            dateRange: file.dateRange,
            fechaInicio: partes[0],
            fechaFin: partes[1],
            costo: this.getCostoFile(egresos)
          })
        }
      })
    )
    console.log(this.files)
    this.dataSource.data = this.files
    this.dataSource.paginator = this.paginator
    this.loading = false
    /*     this.alimentosService.getAllEgresosInsumosByFileId().subscribe(response =>{
      console.log(response)
      this.dishes=response.getAllInsumos;
      this.dataSource.data = this.dishes;
      this.dataSource.paginator = this.paginator
      this.loading=false
    }); */
  }

  getCostoFile (data: any) {
    let costo: number = 0

    data.map((el: any) => {
      costo += el.costo * el.cantidad
    })
    console.log('data')
    console.log(data)
    console.log(costo)
    return costo
  }

  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  applyFilterSelect () {
    let dataNew: any = this.files

    if (this.startDate && this.endDate) {
      dataNew = dataNew?.filter((item: any) => {
        return (
          new Date(this.startDate) <=
            moment(item.fechaInicio, 'DD.MM.YYYY').toDate() &&
          moment(item.fechaFin, 'DD.MM.YYYY').toDate() <= new Date(this.endDate)
        )
      })
    }

    this.dataSource.data = dataNew
  }

  cleanDateSelected () {
    this.startDate = null
    this.endDate = null

    this.applyFilterSelect()
  }
}
